import { render, staticRenderFns } from "./step-login.vue?vue&type=template&id=0fa74488&"
import script from "./step-login.vue?vue&type=script&lang=js&"
export * from "./step-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports